import { Layout, Flex, Button, Input, Tabs, Image } from 'antd';
import MyHeaderOne from '../header';
import MyFooter from '../footer';
import style from './page.module.less'
import { NewspaperFolding, VolumeSmall } from '@icon-park/react';
import axios from 'axios';
import { useState } from 'react';
import { REQUEST_URL } from '../../utils/env';
import img from '../../img/nobg.png'

const { Header, Footer, Content } = Layout;

function Search() {

    const [searchKey, setSearchKey] = useState()
    const [offset, setOffset] = useState(0)

    const inputChange = (value) => {
        setSearchKey(value)
    }

    const [searchKuaibaoResult, setSearchKuaibaoResult] = useState()
    const [searchKeyanResult, setSearchKeyanResult] = useState()
    const [searchXinxiResult, setSearchXinxiResult] = useState()
    const [searchRedianResult, setSearchRedianResult] = useState()


    const searchTitle = async () => {
        try {
            await axios.get(
                REQUEST_URL + '/info/searchInfo',
                { params: { 'searchKey': searchKey, 'offset': offset } }
            ).then((Response) => {
                // console.log(Response.data)
                setSearchKuaibaoResult(Response.data.kuaibao)
                setSearchKeyanResult(Response.data.keyan)
                setSearchXinxiResult(Response.data.xinxi)
                setSearchRedianResult(Response.data.redian)
                console.log(Response.data.redian)
            })
        } catch (error) {
            throw new Error(error)
        }
    }

    const [tabKey, setTabKey] = useState()

    const submitOk = () => {
        setTabKey('1')
        searchTitle()
    }

    const onChange = (key) => {
        console.log(key);
        setTabKey(key)
    };
    const items = [
        {
            key: '1',
            label: '动态监测快报',
        },
        {
            key: '2',
            label: '学术研究成果',
        },
        {
            key: '3',
            label: '信息发布',
        },
        {
            key: '4',
            label: '全球热点追踪',
        },
    ];

    return (
        <Layout className={style.search}>
            <Header className={style.search__header}>
                <MyHeaderOne />
            </Header>
            <Content className={style.search__wapper}>

                <Flex vertical={false} justify='space-between' className={style.search__wapper__two}>
                    <Flex>
                        <Input className={style.search__wapper__two__input} onChange={(e) => inputChange(e.target.value)} placeholder="请输入" width={986} />
                    </Flex>
                    <Flex>
                        <Button className={style.search__wapper__two__button} onClick={submitOk} type='primary'>搜索</Button>
                    </Flex>
                </Flex>
                {(tabKey !== undefined) && <Flex vertical={true} align='start' className={style.search__wapper__three}>
                    <Flex className={style.search__wapper__three__info}>
                        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
                    </Flex>
                    <Flex vertical={true} className={style.search__wapper__three__rs}>
                        {(searchKuaibaoResult !== undefined && searchKuaibaoResult.length > 0 && tabKey === '1') && searchKuaibaoResult.map((item, index) => {
                            return (
                                <Flex key={index} vertical={true} className={style.kycg__wapper__two__left__item}>
                                    <Flex className={style.kycg__wapper__two__left__item__title}><a target='_blank' dangerouslySetInnerHTML={{ '__html': item.title }} href={(item.isUp === '是') ? `./detail?show=xxfb&id=${item.id}` : item.url}></a></Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__info}>{item.info}</Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__date_editor}>{item.pub_date} | {item.author}</Flex>
                                </Flex>
                            )
                        })}

                        {(searchKeyanResult !== undefined && searchKeyanResult.length > 0 && tabKey === '2') && searchKeyanResult.map((item, index) => {
                            return (
                                <Flex key={index} vertical={true} className={style.kycg__wapper__two__left__item}>
                                    <Flex className={style.kycg__wapper__two__left__item__title}><a target='_blank' dangerouslySetInnerHTML={{ '__html': item.title }} href={(item.isUp === '是') ? `./detail?show=xxfb&id=${item.id}` : item.url}></a></Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__info}>{item.info}</Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__date_editor}>{item.pub_date} | {item.author}</Flex>
                                </Flex>
                            )
                        })}

                        {(searchXinxiResult !== undefined && searchXinxiResult.length > 0 && tabKey === '3') && searchXinxiResult.map((item, index) => {
                            return (
                                <Flex key={index} vertical={true} className={style.kycg__wapper__two__left__item}>
                                    <Flex className={style.kycg__wapper__two__left__item__title}><a target='_blank' dangerouslySetInnerHTML={{ '__html': item.title }} href={(item.isUp === '是') ? `./detail?show=xxfb&id=${item.id}` : item.url}></a></Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__info}>{item.info}</Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__date_editor}>{item.pub_date} | {item.author}</Flex>
                                </Flex>
                            )
                        })}

                        {(searchRedianResult !== undefined && searchRedianResult.length > 0 && tabKey === '4') && searchRedianResult.map((item, index) => {
                            return (
                                <Flex key={index} vertical={true} className={style.kycg__wapper__two__left__item}>
                                    <Flex className={style.kycg__wapper__two__left__item__title}><a target='_blank' dangerouslySetInnerHTML={{ '__html': item.title }} href={item.url}></a></Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__info}>{item.info}</Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__date_editor}>{item.pub_date} | {item.author}</Flex>
                                </Flex>
                            )
                        })}
                    </Flex>
                </Flex>}

                {(tabKey === undefined) && <Flex vertical={true} align='start' className={style.search__wapper__three}>
                    <Flex vertical={true} align='center' justify='center' className={style.search__wapper__three__nors}>
                        <Image src={img} width={112} preview={false} ></Image>
                        <Flex style={{ marginTop: '20px', fontSize: '18px', lineHeight: '24px', color: '#999999' }}>暂未搜索到相关信息，请更换关键词重新搜索</Flex>
                    </Flex>
                </Flex>}


            </Content>
            <Footer className={style.search__footer}>
                <MyFooter />
            </Footer>
        </Layout >
    );
}

export default Search;
